import type { MouseEvent } from "react";

export const stopPropagation = (event: MouseEvent<HTMLElement>) => {
  event.stopPropagation();
};

export const keepClickInside = (event: MouseEvent<HTMLElement>) => {
  event.preventDefault();
  event.stopPropagation();
};
